var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.545 4.364a.686.686 0 00-.681.681v8.182c0 .374.308.682.681.682h10.91a.686.686 0 00.681-.682V5.045a.686.686 0 00-.682-.681H3.545zM1.5 5.045A2.05 2.05 0 013.545 3h10.91A2.05 2.05 0 0116.5 5.045v8.182a2.05 2.05 0 01-2.046 2.046H3.545A2.05 2.05 0 011.5 13.227V5.045z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.623 4.654a.682.682 0 01.95-.167L9 8.986l6.427-4.5a.682.682 0 01.782 1.118l-6.818 4.772a.682.682 0 01-.782 0L1.791 5.604a.682.682 0 01-.168-.95z",
    fill: "current"
  })));
}
export default SvgMail;